module.exports = __webpack_public_path__ + "static/media/ceo.b4e3b8e4.jpg";